<template>
  <div id="modalCreateEditCourse" class="modal fade" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ textModal }} Curso</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          />
        </div>
        <form @submit.prevent="save">
          <div class="modal-body">
            <div class="row g-3">
              <div class="col-sm-12">
                <label class="form-label">
                  Nome: <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': v$.course.name.$errors.length }"
                  placeholder="Nome do Curso"
                  v-model="v$.course.name.$model"
                />
                <span
                  v-if="v$.course.name.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
                <span
                  v-if="v$.course.name.minLength.$invalid"
                  class="invalid-feedback"
                >
                  O nome deve possuir pelo menos
                  {{ v$.course.name.minLength.$params.min }} caracteres
                </span>
              </div>
              <div class="col-sm-12">
                <label class="form-label">
                  Descrição: <span class="text-danger">*</span>
                </label>
                <textarea
                  class="form-control"
                  :class="{
                    'is-invalid': v$.course.description.$errors.length,
                  }"
                  placeholder="Descrição do Curso"
                  rows="4"
                  v-model="v$.course.description.$model"
                />
                <span
                  v-if="v$.course.description.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
              <div class="col-sm-6">
                <label class="form-label">
                  Aproveitamento Mínimo (%):
                  <span class="text-danger">*</span>
                </label>
                <input
                  type="number"
                  class="form-control"
                  :class="{
                    'is-invalid': v$.course.minimumGrade.$errors.length,
                  }"
                  min="1"
                  step="1"
                  max="100"
                  placeholder="Ex: 60"
                  v-model="v$.course.minimumGrade.$model"
                />
                <span
                  v-if="v$.course.minimumGrade.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
                <span
                  v-if="v$.course.minimumGrade.between.$invalid"
                  class="invalid-feedback"
                >
                  O valor deve ser entre 1 a 100
                </span>
              </div>
              <div class="col-sm-6">
                <label class="form-label">
                  Instrutor: <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': v$.course.instructor.$errors.length }"
                  placeholder="Instrutor do Curso"
                  v-model="v$.course.instructor.$model"
                />
                <span
                  v-if="v$.course.instructor.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
                <span
                  v-if="v$.course.instructor.minLength.$invalid"
                  class="invalid-feedback"
                >
                  O nome deve possuir pelo menos
                  {{ v$.course.instructor.minLength.$params.min }} caracteres
                </span>
              </div>
            </div>
          </div>
          <div class="modal-footer border-top-0">
            <button
              type="button"
              class="btn btn-link"
              data-bs-dismiss="modal"
              title="Cancelar"
              @click="$emit('closeModal', false)"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="btn btn-primary"
              :title="textModal"
              :disabled="v$.$invalid || disableButton"
            >
              <span v-if="disableButton">
                <i class="ph-spinner spinner" />
              </span>
              <span v-else>{{ textModal }}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required, minLength, between } from '@vuelidate/validators'
import { showModal, hideModal } from '@/utils/modal'

export default {
  name: 'CreateEditCourseModal',

  props: {
    courseId: {
      type: String,
      default: null,
    },
  },

  setup() {
    return { v$: useVuelidate() }
  },

  data() {
    return {
      course: {
        name: '',
        description: '',
        minimumGrade: '',
        instructor: '',
      },
      disableButton: false,
    }
  },

  computed: {
    textModal() {
      return this.courseId ? 'Atualizar' : 'Cadastrar'
    },
  },

  methods: {
    async getCourse() {
      try {
        this.course = await this.$store.dispatch('getCourse', this.courseId)
        showModal('modalCreateEditCourse')
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
        this.$emit('closeModal', false)
      }
    },

    async save() {
      if (!this.v$.$invalid) {
        this.disableButton = true
        try {
          let response = null

          if (this.courseId) {
            response = await this.$store.dispatch('updateCourse', this.course)
          } else {
            response = await this.$store.dispatch('saveCourse', this.course)
          }

          hideModal()
          this.$emit('closeModal', true)
          this.$root.$refs.notification.success(response.message)
        } catch (error) {
          this.disableButton = false
          if (error && error.message) {
            this.$root.$refs.notification.warning(error.message)
          } else {
            this.$root.$refs.notification.error(
              'Não foi possível se conectar ao servidor.',
            )
          }
        }
      }
    },
  },

  validations() {
    return {
      course: {
        name: {
          required,
          minLength: minLength(3),
        },
        description: {
          required,
        },
        minimumGrade: {
          required,
          between: between(1, 100),
        },
        instructor: {
          required,
          minLength: minLength(3),
        },
      },
    }
  },

  mounted() {
    if (this.courseId) {
      this.getCourse()
    } else {
      showModal('modalCreateEditCourse')
    }
  },
}
</script>
